module.exports = __webpack_public_path__ + "media/images/gallery/constellations/vulpecula/vul_pn-6cfa4e0107d9a6f432ed3aa18cce88a1.gif";